


























































































import {Vue, Component} from "vue-property-decorator";
import dataProxy from "../../../services/data-proxy.service";
import {Firma} from "../../../services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PodaciFirme extends mixins(ComponentBaseMixin) {
    podaciFirme = new Firma();

    async created() {
        this.podaciFirme = await this.loadData<Firma>(
            dataProxy.vratiFirmu.bind(dataProxy))() || new Firma();
    }

    async sacuvajFirmu() {
        this.podaciFirme.id = await this.saveData(() => dataProxy.sacuvajFirmu(this.podaciFirme))();
        this.podaciFirme = await this.loadData<Firma>(dataProxy.vratiFirmu.bind(dataProxy))();
    }
}
